import React from 'react';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from '../../format-currency/FormattedCurrency';
import { useCssHandles } from '../../../utils/functions';

import { useCurrentSeller } from '../SellerBody/CurrentSellerContext';
import { useSellerContext } from '../SellerBody/SellerContext';

const SELLERS_CSS_HANDLES = ['sellerShipping', 'sellerShippingText'] as const;

function SellerShipping({ componentId, blockClass }: any) {
	const { shipping } = useCurrentSeller();
	const { limitShownShippingInformation } = useSellerContext();
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.sellerShipping} items-center tc w-100-s w-20-m br2 ph6 pv4 ma0 w-100-s w-20-m`}
		>
			{shipping
				? shipping.slas.slice(0, limitShownShippingInformation).map((sla, index: number) => (
						<p key={index} className={`${handles.sellerShippingText} ma0`}>
							<FormattedMessage
								id="store/seller-list.shipping-estimate"
								values={{
									name: sla.name,
									price: <FormattedCurrency baseCssHandle={`vtex-seller-selector-0-x`} value={sla.price / 100} />,
									estimate: `Normal R$ 5,00 Em até 3 dias úteis`,
								}}
							/>
						</p>
					))
				: `Digite o CEP para calcular`}
		</div>
	);
}

export default SellerShipping;
